import API from "./api";
import router from "@/router";

export default {
  fetchDataConsent(type) {
    return API().get(`data-consent/${type}/${router.currentRoute.params.id}`);
  },
};
